import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUser } from '../utils/userSlice';
import axios from '../utils/axios';
import { logout as logoutUrl, logoutAllDevices } from '../utils/urls';
import { clearSession } from '../utils/session';
import logo from '../Images/Breadcrumb_logo.png';
import './MobileNav.css';

const NavItem = ({ icon, label, onClick, sub = false, danger = false, sm = false }) => (
    <button
        className={`mn-item${sub ? ' mn-item--sub' : ''}${danger ? ' mn-item--danger' : ''}${sm ? ' mn-item--sm' : ''}`}
        onClick={onClick}
    >
        <span className={`mn-icon pi ${icon}`} />
        <span>{label}</span>
    </button>
);

const Section = ({ label }) => <div className="mn-section">{label}</div>;
const Divider = () => <div className="mn-divider" />;

export default function MobileNav({ isSuperuser, is_leader, pipelines, userId, inactivePipelineId }) {
    const [visible, setVisible] = useState(false);
    const [formsOpen, setFormsOpen] = useState(false);
    const [pipelinesOpen, setPipelinesOpen] = useState(false);
    const [libraryOpen, setLibraryOpen] = useState(false);
    const [availabilityOpen, setAvailabilityOpen] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const go = (path) => {
        setVisible(false);
        navigate(path);
    };

    const resetUser = () => {
        dispatch(setUser({
            userId: null, isSuperuser: null, userLable: null,
            image: null, userName: null, ghlUserId: null,
            is_leader: null, designation: ''
        }));
    };

    const handleLogout = async () => {
        try { await axios.post(logoutUrl); } catch {}
        clearSession();
        resetUser();
        navigate('/login');
    };

    const handleLogoutAll = async () => {
        try { await axios.post(logoutAllDevices); } catch {}
        clearSession();
        resetUser();
        navigate('/login');
    };

    return (
        <div className="mobile-nav">
            <button className="mn-hamburger" onClick={() => setVisible(true)}>
                <span className="pi pi-bars" />
            </button>

            <Sidebar
                visible={visible}
                onHide={() => setVisible(false)}
                className="mn-sidebar"
                position="left"
            >
                <div className="mn-header">
                    <img src={logo} alt="Breadcrumbs" className="mn-logo" />
                    <button className="mn-close" onClick={() => setVisible(false)}>
                        <span className="pi pi-times" />
                    </button>
                </div>

                <nav className="mn-nav">
                    <NavItem icon="pi-home"      label="Home"      onClick={() => go('/')} />
                    <NavItem icon="pi-chart-bar" label="Dashboard" onClick={() => go('/dashboard')} />

                    {isSuperuser ? (
                        <>
                            <Section label="Apps" />
                            <NavItem icon="pi-th-large"    label="Apps"          onClick={() => go('/app-kanban/1')} />
                            <NavItem icon="pi-users"       label="Clients"       onClick={() => go('/app-kanban/6')} />
                            <NavItem icon="pi-table"       label="App Table"     onClick={() => go('/app-table/table')} />
                            <NavItem icon="pi-sync"        label="Real Time Apps" onClick={() => go('/real-time-apps/1')} />
                            {pipelines?.length > 0 && (
                                <>
                                    <button
                                        className="mn-expand"
                                        onClick={() => setPipelinesOpen(v => !v)}
                                    >
                                        <span className="mn-icon pi pi-sitemap" />
                                        <span>Pipelines</span>
                                        <span className={`mn-chevron pi pi-angle-down${pipelinesOpen ? ' open' : ''}`} />
                                    </button>
                                    {pipelinesOpen && pipelines.map(pipeline => (
                                        <NavItem
                                            key={pipeline.value}
                                            icon="pi-arrow-right"
                                            label={pipeline.label.replace(/^[^\w]+/, '').trim()}
                                            onClick={() => go(`/app-kanban/${pipeline.value}`)}
                                            sub
                                        />
                                    ))}
                                </>
                            )}

                            <Section label="Forms" />
                            <button
                                className="mn-expand"
                                onClick={() => setFormsOpen(v => !v)}
                            >
                                <span className="mn-icon pi pi-file" />
                                <span>Forms</span>
                                <span className={`mn-chevron pi pi-angle-down${formsOpen ? ' open' : ''}`} />
                            </button>
                            {formsOpen && (
                                <>
                                    <NavItem icon="pi-plus-circle" label="New App"   onClick={() => go('/new-app-form')} sub />
                                    <NavItem icon="pi-bolt"        label="Quick App" onClick={() => go('/new-app-short')} sub />
                                </>
                            )}

                            <Section label="Leaderboards" />
                            <NavItem icon="pi-star"          label="Caller Leaderboard"  onClick={() => go('/callers-leaderboard')} />
                            <NavItem icon="pi-shopping-cart" label="Shopper Leaderboard" onClick={() => go('/shoppers-leaderboard')} />

                            <Section label="Management" />
                            <NavItem icon="pi-megaphone" label="Campaigns"    onClick={() => go('/campaign')} />
                            <NavItem icon="pi-sitemap"   label="Teams"        onClick={() => go('/team')} />
                            <NavItem icon="pi-users"     label="Participants"  onClick={() => go('/participant')} />
                            <NavItem icon="pi-wallet"    label="Purchases"     onClick={() => go('/purchase')} />

                            <Section label="More" />
                            <NavItem icon="pi-cog"        label="Settings"       onClick={() => go('/settings')} />
                            <NavItem icon="pi-refresh"    label="Repeat Leads"   onClick={() => go('/repeat-leads')} />
                            <NavItem icon="pi-list"       label="Queue"          onClick={() => go('/queue')} />
                            <NavItem icon="pi-history"    label="Activity Logs"  onClick={() => go('/activity-logs')} />
                            <NavItem icon="pi-question-circle" label="Help Desk" onClick={() => go('/help-desk')} />
                            {inactivePipelineId && (
                                <NavItem icon="pi-ban" label="Inactive Apps" onClick={() => go(`/app-kanban/${inactivePipelineId}`)} />
                            )}
                            <button
                                className="mn-expand"
                                onClick={() => setLibraryOpen(v => !v)}
                            >
                                <span className="mn-icon pi pi-book" />
                                <span>Library</span>
                                <span className={`mn-chevron pi pi-angle-down${libraryOpen ? ' open' : ''}`} />
                            </button>
                            {libraryOpen && (
                                <>
                                    <NavItem icon="pi-images"  label="Flyers"             onClick={() => go('/library')} sub />
                                    <NavItem icon="pi-play"    label="Training & Scripts"  onClick={() => go('/training-library')} sub />
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <Section label="Apps" />
                            <NavItem icon="pi-th-large" label="Apps"          onClick={() => go('/app-kanban/1')} />
                            <NavItem icon="pi-users"    label="Clients"        onClick={() => go('/app-kanban/6')} />
                            <NavItem icon="pi-sync"     label="Real Time Apps" onClick={() => go('/real-time-apps/1')} />
                            {inactivePipelineId && (
                                <NavItem icon="pi-ban" label="Inactive Apps" onClick={() => go(`/app-kanban/${inactivePipelineId}`)} />
                            )}
                            {pipelines?.length > 0 && (
                                <>
                                    <button
                                        className="mn-expand"
                                        onClick={() => setPipelinesOpen(v => !v)}
                                    >
                                        <span className="mn-icon pi pi-sitemap" />
                                        <span>Pipelines</span>
                                        <span className={`mn-chevron pi pi-angle-down${pipelinesOpen ? ' open' : ''}`} />
                                    </button>
                                    {pipelinesOpen && pipelines.map(pipeline => (
                                        <NavItem
                                            key={pipeline.value}
                                            icon="pi-arrow-right"
                                            label={pipeline.label.replace(/^[^\w]+/, '').trim()}
                                            onClick={() => go(`/app-kanban/${pipeline.value}`)}
                                            sub
                                        />
                                    ))}
                                </>
                            )}

                            <Section label="Forms" />
                            <button
                                className="mn-expand"
                                onClick={() => setFormsOpen(v => !v)}
                            >
                                <span className="mn-icon pi pi-file" />
                                <span>Forms</span>
                                <span className={`mn-chevron pi pi-angle-down${formsOpen ? ' open' : ''}`} />
                            </button>
                            {formsOpen && (
                                <>
                                    <NavItem icon="pi-plus-circle" label="New App"   onClick={() => go('/new-app-form')} sub />
                                    <NavItem icon="pi-bolt"        label="Quick App" onClick={() => go('/new-app-short')} sub />
                                </>
                            )}

                            <Section label="Leaderboards" />
                            <NavItem icon="pi-star"          label="Caller Leaderboard"  onClick={() => go('/callers-leaderboard')} />
                            <NavItem icon="pi-shopping-cart" label="Shopper Leaderboard" onClick={() => go('/shoppers-leaderboard')} />

                            {is_leader && (
                                <NavItem icon="pi-users" label="Participants" onClick={() => go('/participant')} />
                            )}

                            <Section label="More" />
                            <NavItem icon="pi-refresh"          label="Repeat Leads" onClick={() => go('/repeat-leads')} />
                            <NavItem icon="pi-list"             label="Queue"        onClick={() => go('/queue')} />
                            <NavItem icon="pi-question-circle"  label="Help Desk"    onClick={() => go('/help-desk')} />
                            <button
                                className="mn-expand"
                                onClick={() => setLibraryOpen(v => !v)}
                            >
                                <span className="mn-icon pi pi-book" />
                                <span>Library</span>
                                <span className={`mn-chevron pi pi-angle-down${libraryOpen ? ' open' : ''}`} />
                            </button>
                            {libraryOpen && (
                                <>
                                    <NavItem icon="pi-images" label="Flyers"             onClick={() => go('/library')} sub />
                                    <NavItem icon="pi-play"   label="Training & Scripts"  onClick={() => go('/training-library')} sub />
                                </>
                            )}
                            {userId && (
                                <>
                                    <button
                                        className="mn-expand"
                                        onClick={() => setAvailabilityOpen(v => !v)}
                                    >
                                        <span className="mn-icon pi pi-calendar" />
                                        <span>Availability</span>
                                        <span className={`mn-chevron pi pi-angle-down${availabilityOpen ? ' open' : ''}`} />
                                    </button>
                                    {availabilityOpen && (
                                        <>
                                            <NavItem icon="pi-bolt"     label="Live Assignment" onClick={() => go(`/user-availability/${userId}`)} sub />
                                            <NavItem icon="pi-calendar" label="Appointment"      onClick={() => go(`/user-availability-appointment/${userId}`)} sub />
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    )}

                    <Divider />
                    <NavItem icon="pi-sign-out" label="Logout"                  onClick={handleLogout}    danger />
                    <NavItem icon="pi-sign-out" label="Log out of all devices"  onClick={handleLogoutAll} danger sm />
                </nav>
            </Sidebar>
        </div>
    );
}
